import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "14", x: "2", y: "5", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "10", x: "12", y: "7", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 2v20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AlignHorizontalJustifyEnd";
const AlignHorizontalJustifyEnd = memo(themed(Icon));
export {
  AlignHorizontalJustifyEnd
};
//# sourceMappingURL=align-horizontal-justify-end.js.map
